import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import { setCurrentPartnerId, updateSettings } from 'actions/settings'
import Header from 'components/header'
import Footer from 'components/footer'
import ErrorMessage from 'components/error-message'
import ContactUsModal from 'components/contact-us-modal'
import SuperUserBar from 'components/super-user-bar'
import SuperuserSelectorModal from 'components/superuser-selector-modal'
import CropperTool from 'components/cropper-tool'

import '../../styles/global.css'
import './app.css'

class App extends Component {

  componentWillMount() {
    this.props.setCurrentPartnerId(this.props.partnerId)
    this.props.updateSettings()
  }

  render() {
    const { children, routes } = this.props
    const { isFullPage } = routes[routes.length - 1]

    return (
      <div>
        <ContactUsModal />
        <SuperuserSelectorModal />
        {isFullPage ?
          <div>
            {children}
          </div>
        :
          <div>
            <Header />
            <ErrorMessage />
            <div>
              {children}
            </div>
            <Footer />
          </div>
        }
        <SuperUserBar />
        <CropperTool />
      </div>
    )
  }
}

App.propTypes = {
  children: PropTypes.node,
  partnerId: PropTypes.string,
  routes: PropTypes.object.isRequired,
  setCurrentPartnerId: PropTypes.func,
  updateSettings: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => ({
  partnerId: ownProps.params.partnerId,
})

const mapDispatchToProps = {
  push,
  setCurrentPartnerId,
  updateSettings,
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



/** WEBPACK FOOTER **
 ** ./src/containers/app/app.js
 **/